import { Navigate } from "react-router-dom";
import { useAppContext, useAuth } from "../contexts";

const ProtectedRoutes = ({ children }: any) => {
    const { userData } = useAppContext()
    const { isAuthenticated } = useAuth();

    const hasPendingOnboarding = userData?.appOnBoardings?.some((step: any) => !step.isDone);

    if(isAuthenticated && userData?.isNpiVerified && !hasPendingOnboarding){
        return <Navigate to={"/home"}/>;
    }

    return children
}

export default ProtectedRoutes